/**
 * @generated SignedSource<<e4069b32b7fe55152e8eb1c44e1d6551>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphDefault_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly excerpt: string | null;
  readonly id: string;
  readonly lastModifiedDate: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly permissionLevel: string | null;
  readonly subtype: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphDefault_AtlassianSearchPage";
};
export type searchGraphDefault_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphDefault_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphDefault_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
},
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v4 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphDefault_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "f94f2a94cf3a3a359423eadcef3a5758";

export default node;
